 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		25: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"2580449cbdca25622be15cc54f6382e29ccbdcd7","1":"100c9062","2":"b01f64f3","3":"b637e9a5","4":"fdb1769b1c45d420c68378749f56ff456fccd880","5":"bbf0ae3752f5f7e6f392b0b9f086e8067312ab6a","6":"57ac46d285b416f4fafcc5aa8e1051b5e1db19f1","7":"a09686f1","8":"b07aaa4f","9":"55bfca2627b7a7ff0389fc6d4452dbae3f006217","10":"4a754ec80b178711dc26cb30cefd4fcf6c941ecb","11":"05d954cf","12":"476edd5e68b7975907972b0ccb47d07c6996830f","13":"c929556b142d98b066b8861212010a9406a162c3","14":"e8cbb670aba452384e47764d95ca5be58beb1144","15":"framework","16":"5a6f9aa80bec0d55a61c485bbb4a741261969b63","17":"888c22908c6a1b8476a48b8f624821ab43919eb0","18":"component---src-pages-merchant-manageusers-create-js","19":"component---src-pages-merchant-manageusers-dashboard-js","20":"component---src-pages-merchant-manageusers-edit-js","21":"component---src-pages-merchant-statements-graphs-js","22":"component---src-pages-points-checkout-index-js","23":"component---src-pages-rewards-link-index-js","24":"component---src-pages-token-checkout-index-js","31":"component---src-pages-about-au-js","32":"component---src-pages-about-index-js","33":"component---src-pages-about-nz-js","34":"component---src-pages-checkout-js","35":"component---src-pages-embed-shopify-dashboard-js","36":"component---src-pages-error-js","37":"component---src-pages-index-js","38":"component---src-pages-info-js","39":"component---src-pages-merchant-analytics-index-js","40":"component---src-pages-merchant-home-index-js","41":"component---src-pages-merchant-index-js","42":"component---src-pages-merchant-login-callback-js","43":"component---src-pages-merchant-login-index-js","44":"component---src-pages-merchant-logout-js","45":"component---src-pages-merchant-orders-create-js","46":"component---src-pages-merchant-orders-dashboard-js","47":"component---src-pages-merchant-orders-review-js","48":"component---src-pages-merchant-orders-summary-js","49":"component---src-pages-merchant-orders-transactiondashboard-js","50":"component---src-pages-merchant-pos-initiate-js","51":"component---src-pages-merchant-pos-orders-summary-js","52":"component---src-pages-merchant-promotions-index-js","53":"component---src-pages-merchant-reports-index-js","54":"component---src-pages-merchant-selectmerchant-index-js","55":"component---src-pages-merchant-statements-settlementsummary-js","56":"component---src-pages-merchant-trainingguides-index-js","57":"component---src-pages-outcome-js","58":"component---src-pages-payment-complete-js","59":"component---src-pages-playground-checkout-js","60":"component---src-pages-playground-widget-js","61":"component---src-pages-playground-widget-testing-js","62":"component---src-pages-points-index-js","63":"component---src-pages-points-login-callback-js","64":"component---src-pages-points-login-index-js","65":"component---src-pages-purchase-initiate-js","66":"component---src-pages-rewards-index-js","67":"component---src-pages-rewards-login-callback-js","68":"component---src-pages-rewards-login-index-js","69":"component---src-pages-shopify-about-js","70":"component---src-pages-shopify-auth-js","71":"component---src-pages-shopify-install-js","72":"component---src-pages-shopify-payment-index-js","73":"component---src-pages-shopify-payment-outcome-js","74":"component---src-pages-shopify-payment-settings-js","75":"component---src-pages-token-index-js","76":"component---src-pages-token-login-callback-js","77":"component---src-pages-token-login-index-js","78":"component---src-pages-token-logout-js","79":"component---src-pages-wallet-checkout-index-js","80":"component---src-pages-wallet-index-js","81":"component---src-pages-wallet-login-callback-js","82":"component---src-pages-wallet-login-index-js","83":"component---src-pages-wallet-logout-js"}[chunkId]||chunkId) + "-" + {"0":"9c7ab68e95ac88afea70","1":"c091cbacc5bda877d9a4","2":"ea308e89d5bc7ded764d","3":"7fd41b8cceebac90b3b5","4":"3829f0593ea1d0b4b73e","5":"949abed439fa27833cc7","6":"5ea96e30771a600f3b41","7":"c28159cfc4e1bff2af4b","8":"380a0bf1b45786717cb9","9":"68cfa0e6d0c1843fba06","10":"ed5c900e90077e03be47","11":"245a485420726d245cd9","12":"9e6ce524b5d7c6e7b0af","13":"9c9ac9c2298b618c8947","14":"7a1786b3a46d6b0e5961","15":"b3e4be764f315c02d1fb","16":"ce27f97038c96b5855e8","17":"4f795f9321d9b199ccb5","18":"ea5c94b32a44529a0e11","19":"befd51313c3bfa66e9b0","20":"c23ef30c2b163bdbb967","21":"964ceda35e1b2f6fe9bb","22":"141202abe468e783b480","23":"37a0e77283defb276e8c","24":"3de8833d7e348cf7b455","26":"84aa5307dad3094fd512","31":"5892ed791ae11376b6f8","32":"12d1ebac7f02d2c11b51","33":"b4c57ae46baa0862e96e","34":"ef6a98dadc6123023d7c","35":"478f6f266a5fc7eb8044","36":"4dd1eb40a130cb40f78a","37":"b8d620ffbe0b2bd26f40","38":"39cb939c4604bc747389","39":"06174131abf34b84f319","40":"a7bc6088e384a14810d9","41":"a4c533b4d47cf9191b60","42":"98fe7e5a5d01faf7c060","43":"ea831a50213a1a45c05c","44":"3d33ed2c02cc628398ad","45":"3f12c7c6cf0e074736f4","46":"6506f349d51ff5cad864","47":"170946243a357366f154","48":"13c970f1008c9abd4a85","49":"3f26d747e1172bfeb6f8","50":"806f30433ca66734994b","51":"59af2bc9985117fa382b","52":"6e9d9cc390ab9fe93563","53":"fe4db4018863b6f75741","54":"70ca3aecd122ea9590c3","55":"0168dd80905ec9fc6e80","56":"dac93d92132cdf4692a6","57":"4dd37c5cbbe098b8d1b9","58":"d565b1f588c6ed34c584","59":"7e3fdcc7ffc92733f9b5","60":"0a60297158cc688a1fd2","61":"7422e812d04e5d149055","62":"c41e17b820a11d35e27a","63":"453f42718ff07a071ee9","64":"9d6e30e2bf842fd69bb4","65":"dfa81239423509223b19","66":"14e82d63f457bed59cb5","67":"eba9d861598a57b76670","68":"18f85946fc502bc48e25","69":"69c0d060750480ffbb3a","70":"7cfe8ca06c16e0a81a1d","71":"110af0d6f091efdab03a","72":"0a22c8e4b6fedb60b224","73":"d0a05b0d6b6936cf80d8","74":"338f0a10aa9f91efcf2b","75":"45946578baeee5c4ee69","76":"b8f3223dd2802269d990","77":"6f59b4310bf772570d37","78":"91596776f03b38fda390","79":"1c87a5fd78cf912d60d7","80":"555c1d0c3d3dbedee163","81":"d622290bca38fe7ea55b","82":"6ad3b652a968c496c526","83":"bfdc6e63f7f8cfc1013c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
